import { useContext } from 'react';

import { QBankStructureHeaderModalContext } from './qbank-structure-header-modal-provider';

function useQBankStructureHeaderModal() {
  const context = useContext(QBankStructureHeaderModalContext);

  if (!context) {
    throw new Error(
      'useQBankStructureHeaderModal must be used within a QBankStructureHeaderModalActionProvider',
    );
  }

  return context;
}

export { useQBankStructureHeaderModal };
